import { transport } from 'config/transport';

export function callApiGetGradeHolidays(gradeId, params) {
    return transport.get(`/mamnon/grades/${gradeId}/holidays`, { params });
}
